import { render, staticRenderFns } from "./ManageGameListTab.vue?vue&type=template&id=160e694b&scoped=true"
import script from "./ManageGameListTab.vue?vue&type=script&lang=js"
export * from "./ManageGameListTab.vue?vue&type=script&lang=js"
import style0 from "./ManageGameListTab.vue?vue&type=style&index=0&id=160e694b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e694b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('160e694b')) {
      api.createRecord('160e694b', component.options)
    } else {
      api.reload('160e694b', component.options)
    }
    module.hot.accept("./ManageGameListTab.vue?vue&type=template&id=160e694b&scoped=true", function () {
      api.rerender('160e694b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/gameManage/components/ManageGameListTab.vue"
export default component.exports